<template>
  <div class="home">
    <h1>Atlas SPA Test - Home Page</h1>
    <p>This is the home page of our WP Engine Atlas SPA test app.</p>
    <p>Try navigating to <a href="/nonexistent">a non-existent route</a> to test the 404 handling.</p>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
.home {
  padding: 2rem;
}
</style>